/* eslint-disable */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { getDateFormat, getTimeFormat } from 'legacy/constants';

const FormattedDate = props => {
  const dispatch = useDispatch();
  const me = useSelector(state => state.app.dataSources.me);
  const { fmt, date, id } = props;

  const getDate = d => {
    if (!d) {
      return '-';
    }

    const defaultFmt = `${getDateFormat(me)} ${'\n'} ${getTimeFormat(me)}`;
    const displayFormat = fmt || defaultFmt;
    return moment(d).calendar(null, {
      nextDay: displayFormat,
      nextWeek: displayFormat,
      lastWeek: displayFormat,
      sameElse: displayFormat,
      sameDay: displayFormat,
      lastDay: displayFormat,
    });
  };

  return <span id={id}>{getDate(date).replaceAll('-', '/')}</span>;
};

export default FormattedDate;



// WEBPACK FOOTER //
// ./src/views/components/Common/FormattedDate/FormattedDate.jsx